import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./Azure-ad/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
// const adtype = sessionStorage.getItem("adtype");
// const local = localStorage.getItem("adtype");
// console.log(adtype,local);
// if(adtype == null){
//   console.log("form Index:",adtype);
// }
// else{
//   console.log("form Index in else:",adtype);
// }
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <MsalProvider instance={msalInstance}> */}
        <App />
      {/* </MsalProvider> */}
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
